import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import ManagerLogin from "@/pages/ManagerLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CreateRestaurant from "@/pages/CreateRestaurant";
import KioskLogin from "@/pages/KioskLogin";
import JoinRestaurant from "@/pages/JoinRestaurant";
import StaffHome from "@/pages/StaffHome";
import ShiftChecklist from "@/pages/ShiftChecklist";
import ManagerDashboard from "@/pages/ManagerDashboard";
import Templates from "@/pages/Templates";
import Schedule from "@/pages/Schedule";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import MasterAdmin from "@/pages/MasterAdmin";
import TopBar from "@/components/TopBar";

const Loading = () => (
  <div className="min-h-screen grid place-items-center bg-[#FBF8F3]">
    <div className="text-terra-600 font-display text-xl animate-pulse">Firing up the line…</div>
  </div>
);

const Protected = ({ children, managerOnly = false }) => {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  if (managerOnly && user.primary_role !== "Manager") return <Navigate to="/app" replace />;
  return (
    <div className="min-h-screen bg-[#FBF8F3]">
      <TopBar />
      {children}
    </div>
  );
};

const GuestOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (user) return <Navigate to={user.primary_role === "Manager" ? "/manager" : "/app"} replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GuestOnly><Landing /></GuestOnly>} />
            <Route path="/login" element={<GuestOnly><ManagerLogin /></GuestOnly>} />
            <Route path="/forgot-password" element={<GuestOnly><ForgotPassword /></GuestOnly>} />
            <Route path="/reset-password" element={<GuestOnly><ResetPassword /></GuestOnly>} />
            <Route path="/create-restaurant" element={<GuestOnly><CreateRestaurant /></GuestOnly>} />
            <Route path="/kiosk" element={<GuestOnly><KioskLogin /></GuestOnly>} />
            <Route path="/join" element={<GuestOnly><JoinRestaurant /></GuestOnly>} />
            <Route path="/app" element={<Protected><StaffHome /></Protected>} />
            <Route path="/app/shift/:id" element={<Protected><ShiftChecklist /></Protected>} />
            <Route path="/manager" element={<Protected managerOnly><ManagerDashboard /></Protected>} />
            <Route path="/manager/templates" element={<Protected managerOnly><Templates /></Protected>} />
            <Route path="/manager/schedule" element={<Protected managerOnly><Schedule /></Protected>} />
            <Route path="/manager/settings" element={<Protected managerOnly><Settings /></Protected>} />
            <Route path="/manager/team" element={<Protected managerOnly><Team /></Protected>} />
            <Route path="/master" element={<MasterAdmin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
